import { status } from 'skin/event/status'

const payment = (obj, table, story, d, action) => {
	console.log('[Оплата] событие', obj)
	if (obj.action === 'row') return status.ignore
	return status.action
}
export default payment
